import AulaService from '../../services/AulaService'
import router from '../../router'

const state = () => ({
    loadingAulas: false,
    aula: [],
    aulasSearch: [],
    aulasAssistidas: JSON.parse(localStorage.getItem('aulasAssistidas')) || [],
    keyword: ''
})
  
const mutations = {
    SET_AULA: (state, aula) => {
        state.aula = aula;
    },
    SET_AULAS_SEARCH: (state, aulas) => {
        state.aulasSearch = aulas;
    },
    SET_LOADING_AULAS: (state, payload) => {
        state.loadingAula = payload
    },
    SET_AULAS_ASSISTIDAS: (state, payload) => {
        state.aulasAssistidas = payload
        localStorage.setItem('aulasAssistidas', JSON.stringify(payload));
    },
}

const actions = {
    async fetchAula({commit}, id){
        try{
            commit('SET_LOADING_AULAS', true)
            const response = await AulaService.getOne(id);
            commit('SET_AULA', response.data)
            commit('SET_LOADING_AULAS', false)
        } catch (error) {
            commit('SET_LOADING_AULAS', false);
            const status = error?.response?.status;
            const data = error?.response?.data || {};

            // Aulas sequenciais: aula bloqueada -> volta para a disciplina com aviso (sem deslogar)
            if (data.code === 'AULA_BLOQUEADA') {
                commit('SET_AULA', []);
                commit('SET_ALERT', { heading: 'info', message: data.message });
                router.push(data.idDisciplina ? `/subject/${data.idDisciplina}` : '/');
                return;
            }

            // Aula ainda não liberada / não encontrada: aviso e volta para a home (sem deslogar)
            if (status === 403 || status === 404) {
                commit('SET_AULA', []);
                commit('SET_ALERT', { heading: 'error', message: data.message || 'Aula indisponível.' });
                router.push('/');
                return;
            }

            if (data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: data.message
            });
        }
    },
     async fetchAulas({commit}, params = {}){
        try{
            commit('SET_LOADING_AULAS', true)
            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'ID', column: 'ID', sort: 'ASC' }, idCategory = null } = params;
            const response = await AulaService.get(keyword, pageNumber, pageSize,  order, idCategory);
            commit('SET_AULAS', response.data)
            commit('SET_LOADING_AULAS', false)
        } catch (error) {
            commit('SET_LOADING_AULAS', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async registrarVisualizacao({commit, rootState, dispatch}) {
        try{
            const aula = rootState.aulas.aula
            if(!aula || aula == []){
                commit('SET_ALERT', {
                    heading: 'error',
                    message: "Aula não encontrada"
                });
            }
            const response = await AulaService.setAulaConcluida({AulaId: aula.id});

            if (response.data.heading === 'success') {
                commit('SET_ALERT', {
                    heading: 'success',
                    message: response.data.message
                });
            } else if (response.data.heading === 'info') {
                console.log("Aula concluída [ registrarVisualizacao ], error: " + response.data.message);
                return;
            } else {
                commit('SET_ALERT', {
                    heading: 'erro',
                    message: response.data.message
                });
                return;
            }

            dispatch('fetchAula', aula.id)
            dispatch('fetchSubject', aula.idDisciplina)
            dispatch('fetchProgressGeneral')
        }catch(error){
            commit('SET_ALERT', {
                heading: 'erro',
                message: error.response.data.message
            });
        }
    },
    async fetchVideosAssistidos({commit}){
        try {
            commit('SET_LOADING_AULAS', true);
            const response = await AulaService.getAllAulasAssistidas();
            commit('SET_AULAS_ASSISTIDAS', response.data);
      
            commit('SET_LOADING_AULAS', false);
        } catch (error) {
            commit('SET_LOADING_AULAS', false);
            commit('LOG_USER_OUT');
        }
    },
}

const getters = {
    getAula: state => state.aula,
    getAulasAssistidas: state => state.aulasAssistidas,
    getAulasPesquisada: state => state.aulasSearch,
    getLoadingAula: state => state.loadingAulas,
}

export default {
    state,
    getters,
    mutations,
    actions
};